import React from "react";
import {Link} from "react-router-dom";

import {WhatsappSupportButton} from "../../../_defaultComponents/WhatsappSupportButton/WhatsappSupportButton";
import {LanguageSwitch} from "../../../_defaultComponents/LanguageSwitch/LanguageSwitch";
import {ContactInfo} from "../components/contactInfo/ContactInfo";
import {CustomerFooter} from "../components/customerFooter/CustomerFooter";
import {VigoMapBG} from "../components/vigoMapBG/VigoMapBG";
import {Content} from "./CustomerSubPageLayout.styles";
import {CandidateLayer} from "../components/candidateLayer/CandidateLayer";
import {CodPaymentMethodSelectionLayer} from "../components/codPaymentMethodSelectionLayer/CodPaymentMethodSelectionLayer";
import {
    SubPageContainer,
    SubPageContent
} from "../customerFluidSubPageLayout/CustomerFluidSubPageLayout.styles";
import {VigoGreenBG} from "../components/vigoGreenBG/VigoGreenBG";

const DEFAULT_OPTIONS = {
    showLogo: true,
    showSideMenu: true,
    showBackButton: true,
    showLanguageSwitch: false,
    showContactInfo: true,
    showFooter: true,
    showWhatsappSupportButton: true,
    showCodPaymentMethodSelectionLayer: true
};

export const CustomerSubPageLayout = ({options = DEFAULT_OPTIONS, pageTitle = "", children}) => {
    options = {...DEFAULT_OPTIONS, ...options};
    return (
        <>
            {/* If user is candidate, then show candidate overlay */}
            <CandidateLayer />
            {Boolean(options?.showCodPaymentMethodSelectionLayer) ? (
                <CodPaymentMethodSelectionLayer />
            ) : (
                <></>
            )}
            <SubPageContainer>
                <SubPageContent>
                    {/* {options?.showLogo ? (
                        <Link to={{pathname: "/musteri"}}>
                            <PanelLogo />
                        </Link>
                    ) : (
                        <></>
                    )} */}
                    {/* {options?.showSideMenu ? <CustomerMenu /> : <></>} */}
                    {options?.showLanguageSwitch ? <LanguageSwitch /> : <></>}
                    {/* {options?.showBackButton || pageTitle ? (
                        <PageHeaderRow>
                            {options?.showBackButton ? <BackButton /> : <></>}
                            {pageTitle ? <PageTitle title={pageTitle} /> : <></>}
                        </PageHeaderRow>
                    ) : (
                        <></>
                    )} */}
                    <Content>{children}</Content>
                    {/* {options?.showContactInfo ? <ContactInfo /> : <></>} */}
                    {options?.showFooter ? <CustomerFooter /> : <></>}
                    {options.showWhatsappSupportButton ? <WhatsappSupportButton /> : <></>}
                </SubPageContent>
                <VigoMapBG />
                <VigoGreenBG />
            </SubPageContainer>
        </>
    );
};
